module.exports = window['Shopware']?.['Vue']